import { render } from "./FaqManageCreateForm.vue?vue&type=template&id=9bfd237e&lang=true"
import script from "./FaqManageCreateForm.vue?vue&type=script&lang=js"
export * from "./FaqManageCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__